/// <reference path="../../trp/services/globalisation.service.ts"/>
/// <reference path="../services/countryPicker.service.ts"/>
'use strict';

namespace ekh {

    type Tenant = TR.ITenant;
    type Region = TR.IRegion;
    type PointOfSale = TR.IPointOfSale;
    type Language = TR.ILanguage;
    type IGlobalisationService = TR.IGlobalisationService;
    type ITenant = TR.ITenant;
    type IRegionalContext = TR.IRegionalContext;

    class CountryPickerPopup {

        activeContext: IRegionalContext;
        countryPickerPopupOpen:boolean = false;
        countryPickerHeaderMessage: string;
        countryPickerSelectionMessage: string;
        template:string;

        constructor(
            private $scope: ng.IScope,
            private broker:any,
            private countryPickerService:ICountryPickerService,
            private $location: ng.ILocationService,
            private resourceService:Core.ResourceService)
        {

            this.countryPickerSelectionMessage = this.resourceService.get('COUNTRYPICKERWESELECTEDMESSAGE');
            this.countryPickerHeaderMessage = this.resourceService.get('COUNTRYPICKERWESELECTEDHEADERMESSAGE');

            broker.subscribe('countryPickerPopup', 'RegionalContextSelected', ev => {
                this.activeContext = ev.data;
                this.countryPickerPopupOpen = true;

                this.countryPickerSelectionMessage = String.format(
                    this.resourceService.get(!this.activeContext.Inferred
                        ? 'COUNTRYPICKERYOUSELECTEDMESSAGE'
                        : 'COUNTRYPICKERWESELECTEDMESSAGE'),
                    this.activeContext.PointOfSale.Country.Name);

                this.countryPickerHeaderMessage = String.format(
                    this.resourceService.get(!this.activeContext.Inferred
                        ? 'COUNTRYPICKERYOUSELECTEDHEADERMESSAGE'
                        : 'COUNTRYPICKERWESELECTEDHEADERMESSAGE'),
                    this.activeContext.PointOfSale.Country.Name,
                    this.activeContext.Language ? this.activeContext.Language.Name : '');
            });

            $scope.$on('$destroy', () => {
                broker.unsubscribe('countryPickerPopup');
            });
        }

        getPointOfSaleUrl = ():string => {
            if(this.activeContext && this.activeContext.PointOfSale) {
                if(this.activeContext.PointOfSale.Id === 0){
                    return '/';
                }
                let countryCode = this.activeContext.PointOfSale.CountryCode.toLowerCase();
                let languageCode = this.activeContext.Language ? this.activeContext.Language.Code.substr(0, 2) : 'en';

                return `/${countryCode}_${languageCode}`;
            }
            return '';
        }

        setPointOfSale = (e):void => {
            if(e){
                e.preventDefault();
                e.stopPropagation();
            }
            this.countryPickerService.selectRegionalContext(this.activeContext)
                .then(regionalContext => {
                    this.activeContext = regionalContext;
                    this.countryPickerPopupOpen = false;
                });
        }
    }

    angular
        .module('ekh')
        .directive('countryPickerPopup', () => {
            return {
                restrict: 'E',
                templateUrl: 'partials/popups/countrypicker',
                controller: CountryPickerPopup,
                controllerAs: 'cpp',
                bindToController: true
            };
        });

}
